<template>
  <div ref="wang"></div>
</template>

<script>
import wangeditor from 'wangeditor'
import axios from 'axios'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      temp: '',
      editor: null,
      isChange: false,
      access_token: this.$store.state.userInfo.access_token || JSON.parse(localStorage.getItem('user_info')).access_token
    }
  },
  watch: {
    value (m) {
      // if(this.editor&&m!=this.temp){
      //   this.editor.$textElem.html(m)
      // }
      if (!this.isChange) {
        this.editor.$textElem.html(m)
      }
      this.isChange = false
    }
  },
  mounted () {
    this.editor = new wangeditor(this.$refs.wang)
    // 配置菜单栏，删减菜单，调整顺序
    this.editor.config.menus = [
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'foreColor', // 文字颜色
      'justify', // 对齐方式
      //'quote', // 引用
      //'image', // 插入图片
      'table', // 表格
      //'video', // 插入视频
    //   'undo', // 撤销
    //   'redo', // 重复
      'fullscreen' // 全屏
    ]
    this.editor.txt.eventHooks.changeEvents.push(() => {
      this.isChange = true
      this.$emit('input', this.editor.$textElem.html())
    })
    this.editor.config.height = 200
    // 上传本地图片
    this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024 // 5M
    this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
    this.editor.config.uploadImgMaxLength = 1 // 一次最多上传 1 个图片
    this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
      const formData = new FormData()
      formData.append('file', resultFiles[0])
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.access_token || '')
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          insertImgFn(`${_this.$resBasePath}/${res.data.url}`)
        }
      })
    }
    this.editor.config.focus = false
    this.editor.create()
    if (this.value.length) {
      this.editor.txt.html(this.value)
    }
  }
  // beforeDestroy(){
  //   if(this.editor){
  //     this.editor.destory()
  //   }
  // }
}
</script>
